/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Cancelatperiodend4Inputs */

const zh_adminsubs_cancelatperiodend4 = /** @type {(inputs: Adminsubs_Cancelatperiodend4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到期取消`)
};

const en_adminsubs_cancelatperiodend4 = /** @type {(inputs: Adminsubs_Cancelatperiodend4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel at Period End`)
};

const es_adminsubs_cancelatperiodend4 = /** @type {(inputs: Adminsubs_Cancelatperiodend4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar al final del período`)
};

/**
* | output |
* | --- |
* | "Cancel at Period End" |
*
* @param {Adminsubs_Cancelatperiodend4Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_cancelatperiodend4 = /** @type {((inputs?: Adminsubs_Cancelatperiodend4Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Cancelatperiodend4Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_cancelatperiodend4(inputs)
	if (locale === "en") return en_adminsubs_cancelatperiodend4(inputs)
	return es_adminsubs_cancelatperiodend4(inputs)
});
export { adminsubs_cancelatperiodend4 as "adminSubs_cancelAtPeriodEnd" }